import React, { useEffect, useRef, useState } from 'react'
import filter from '../../assets/icons/filter.svg'
import { useDispatch } from 'react-redux';


function Filter({ setState, option, onFilterChange }) {
    const filterData = [{'value':0,'label':'All'},...option];
    const [open, setOpen] = useState(false);
    const [current, setCurrent] = useState(filterData[0])
    const drop = useRef(null);
    const isInitialMount = useRef(true);
    const dispatch = useDispatch()

    function handleClick(e) {
        if (drop.current && !drop.current.contains(e.target) && open) {
            setOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener("click", handleClick);
        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [open]);

    function handleItemClick(e, item) {
        e.stopPropagation();
        setOpen(false);
        setCurrent(item);
        
        // Update kelas state and trigger callback immediately
        if (setState) {
            const kelasValue = item.label === 'All' ? '' : item.label;
            dispatch(setState({ name: 'kelas', value: kelasValue }));
            
            // Trigger filter change callback if provided
            if (onFilterChange) {
                onFilterChange(kelasValue);
            }
        }
    }

    function handleFilterClick(e) {
        // Only toggle if clicking on the filter icon, not on the dropdown
        if (e.target.tagName === 'IMG' || !open) {
            setOpen(open => !open);
        }
    }

    return (
        <div className='filter' ref={drop} onClick={handleFilterClick}>
            <img src={filter} alt="" />
            {open &&
                <ul onClick={(e) => e.stopPropagation()}>
                    {filterData.map((item, i) => (
                        <li 
                            key={i} 
                            className={item.label === current?.label ? 'activeDropdownli' : ''} 
                            onClick={(e) => handleItemClick(e, item)}
                        >
                            {item.label || item}
                        </li>
                    ))}
                </ul>
            }
        </div>
    )
}

export default Filter